import { useMutation } from '@common/hooks';
import { Modal, Form, message } from 'antd';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { EditAssignmentForm } from './edit-assignment-form';
import { ASSIGNMENT_SOURCE_MUTATION } from './edit-assignment-term-helper';

export function EditAssignmentModal({
  assignmentTermId,
  showModal,
  onClose,
  isExtension,
  activeTermsEffectiveDates,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!showModal) {
      form.resetFields();
    }
  }, [showModal, form]);

  const [performAssignmentTermMutation, { loading: mutationLoading }] =
    useMutation(ASSIGNMENT_SOURCE_MUTATION, {
      onCompleted: (response) => {
        if (response?.updateAssignmentTermsSource.errors) {
          const errorMessage =
            response.updateAssignmentTermsSource.errors[0]?.errors?.[0];
          message.error(`Error: ${errorMessage}`);
        } else {
          message.success('Term has been updated');
          onClose();
        }
      },
      onError: () => message.error('Error occurred, try again later'),
      refetchQueries: ['CandidateAssignmentQuery'],
    });

  const onSubmit = (values) => {
    performAssignmentTermMutation({
      variables: {
        input: {
          ...values,
        },
        assignmentTermId,
      },
    });
  };

  return (
    <>
      <Modal
        className="EditTermDatesModal"
        title={isExtension ? 'Edit Extension' : 'Edit Assignment'}
        open={showModal}
        onCancel={onClose}
        onOk={form.submit}
        okText="Save"
        okButtonProps={{ loading: mutationLoading }}
        width={550}
        centered
      >
        <EditAssignmentForm
          assignmentTermId={assignmentTermId}
          form={form}
          onSubmit={onSubmit}
          isExtension={isExtension}
          activeTermsEffectiveDates={activeTermsEffectiveDates}
        />
      </Modal>
      <style jsx>{`
        :global(.EditTermModal .ant-modal-footer) {
          text-align: right;
        }
      `}</style>
    </>
  );
}

EditAssignmentModal.propTypes = {
  assignmentTermId: PropTypes.string.isRequired,
  showModal: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  isExtension: PropTypes.bool.isRequired,
  activeTermsEffectiveDates: PropTypes.arrayOf(PropTypes.string),
};
